const satelite = {
  // Satelites vendibles, para elegir cual incluye el producto
  readSatelitesJuedroop: 'satelites/juedroop',
  readSatelitesEvaluacion: 'satelites/evaluacion',

  // Planes de Inteligencia Artificial vendibles: mensuales y paquetes de creditos. Son satelites
  // como los Droops; no confundir con AcademiaIa del core, que es otra cosa (facturacion)
  readSatelitesIaMensual: 'satelites/ia-mensual',
  readSatelitesIaCreditos: 'satelites/ia-creditos',

  // Satelites incluidos en un producto. El PUT manda solo las claves que cambian: una clave ausente
  // no se toca, null la quita y un uuid la incluye
  readProductoSatelites: 'producto/{{uuid_producto}}/satelites',
  updateProductoSatelites: 'producto/{{uuid_producto}}/satelites',

  // Si el producto puede incluir un satelite del tipo que va en ?tipo=, y si no, que planes lo
  // impiden. Es el paso previo al update: cada satelite admite solo su forma de cobro (un Droop, solo
  // suscripcion), asi que el producto no puede tener planes de otra
  readProductoSatelitesValidacion: 'producto/{{uuid_producto}}/satelites/validacion'
}

export default satelite
